import { createSlice } from "@reduxjs/toolkit";
import {
  registerUser,
  verifyOtp,
  resendOtp,
  setPassword,
} from "../thunks/registerThunks";

const initialState = {
  step: 1,
  loading: false,
  email: "",
  user_id: null,
  token: null,
  error: null,
};

const registerSlice = createSlice({
  name: "register",
  initialState,
  reducers: {
    prevStep: (state) => {
      state.step -= 1;
    },
    resetRegister: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      /* EMAIL */
      .addCase(registerUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        state.loading = false;
        state.step = 2;
        state.email = action.payload.data.email;
        state.user_id = action.payload.data.userID;
        // console.log("The user id is :", state.user_id);
      })

      .addCase(registerUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* OTP */
      .addCase(verifyOtp.pending, (state) => {
        state.loading = true;
      })
      .addCase(verifyOtp.fulfilled, (state) => {
        state.loading = false;
        state.step = 3;
      })
      .addCase(verifyOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* PASSWORD */
      .addCase(setPassword.pending, (state) => {
        state.loading = true;
      })
      .addCase(setPassword.fulfilled, (state, action) => {
        state.loading = false;
        state.token = action.payload.token;
      })
      .addCase(setPassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { prevStep, resetRegister } = registerSlice.actions;
export default registerSlice.reducer;
